import { observer } from 'mobx-react';
import { FC, ReactElement, useMemo } from 'react';
import WebhookEditStatus from '../../components/WebhookEditStatus/WebhookEditStatus';
import { webhookEditStore } from '../../store';
import { ORDER_STATUS } from '~/constants/order';
import Text, { TEXT } from '~/view/components/Text/Text';
import './style.scss';

const WebhookEditStatusesBlock: FC = observer((): ReactElement => {
  const statuses = useMemo(
    (): string[] =>
      Object.values(ORDER_STATUS).filter(
        (status) => !new Set([ORDER_STATUS.DRAFT, ORDER_STATUS.ON_HOLD, ORDER_STATUS.WAITING_FOR_PAYMENT]).has(status)
      ),
    []
  );

  return (
    <div className="webhook-edit-statuses-block">
      <Text type={TEXT.SECTION_HEADER} text="statuses" />

      <ul className="webhook-edit-statuses-block__list">
        {statuses.map((status) => (
          <WebhookEditStatus key={status} status={status as ORDER_STATUS} />
        ))}
      </ul>

      {!webhookEditStore.validation.statuses.isValid && <Text type={TEXT.ERROR} text="min_one_status_required" />}
    </div>
  );
});

export default WebhookEditStatusesBlock;
